import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-stub" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "mt-6" }

import stubSvg from '@/assets/stub.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'VStub',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(stubSvg),
      alt: "stub-content"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})